import { MarkerType } from 'reactflow'

export const getEdgesFromRoutes = (routes, activities = []) => {
  return routes.map((route) => {
    const sourceActivity = activities.find((it) => route.from_activity_template_id == it.id)
    const targetActivity = activities.find((it) => route.to_activity_template_id == it.id)

    const color = getRandomColor(route.route_type)
    return {
      id: `r-${route.from_activity_template_id}-${route.to_activity_template_id}`,
      label: route.route_template_name,
      source: route.from_activity_template_id + '',
      target: route.to_activity_template_id + '',
      type: 'smoothstep',
      markerEnd: {
        type: MarkerType.ArrowClosed,
        width: 20,
        height: 20,
        color: color,
      },
      style: {
        strokeWidth: 3,
        stroke: color,
      },
      sourceActivity,
      targetActivity,
      route: route,
    }
  })
}

export const getNodesFromActivities = (activities = []) => {
  return activities
    .sort((a, b) => a.rank - b.rank)
    .map((activity, index) => ({
      id: activity.id + '',
      type: getNodeType(activity),
      position: { x: index * 240 + 20, y: index * 160 + 20 },
      data: { activity },
      style: { visibility: 'visible' },
      ...activity.workflow_metadata,
    }))
}

const getNodeType = (activity) => {
  if (activity.is_start) {
    return 'startActivity'
  } else {
    if (activity.activity_type == 'end-rejected') {
      return 'endRejectedActivity'
    } else if (activity.activity_type == 'end-accepted') {
      return 'endAcceptedActivity'
    } else {
      return 'activity'
    }
  }
}

export const getRandomColor = (type) => {
  const colors = [
    '#f52c1d',
    '#fa7705',
    '#faf205',
    '#67fa05',
    '#05fa3e',
    '#05fac5',
    '#059cfa',
    '#0536fa',
    '#4e05fa',
    '#cd05fa',
    '#fa059c',
    '#f2054c',
  ]
  return colors[Math.floor(Math.random() * colors.length)]

  // if (type == 'progress') {
  //   return '#06c723'
  // } else if (type == 'regress') {
  //   return '#f20528'
  // } else {
  //   return '#808080'
  // }
}
